<div class="main-container ac-table-page">
  <header class="page-header">
    <div class="title">
      <span class="title-text">Manage Users</span>
      <p class="small-title">Branch staff, their roles and permissions, and access status.</p>
    </div>

    <div class="header-actions">
      <input
        type="search"
        class="text-box-active search-box"
        placeholder="Search name, username or mobile"
        aria-label="Search users"
        [formControl]="search"
      />
      @if(canManage){
      <button type="button" class="ac-primary-btn" [disabled]="isLoading" (click)="addStaff()">Add Staff</button>
      }
    </div>
  </header>

  <div class="table-container ac-table-region" role="region" aria-label="Branch staff" tabindex="0">
    <table class="table ac-responsive-table ac-sortable-table" matSort [matSortDisableClear]="true" (matSortChange)="sortStaff($event)">
      <thead class="table-head">
        <tr>
          <th scope="col" mat-sort-header="fullName" data-mobile-sort>Name</th>
          <th scope="col" mat-sort-header="userName" data-mobile-sort>Username</th>
          <th scope="col" mat-sort-header="mobileNumber">Mobile</th>
          <th scope="col" mat-sort-header="access" data-mobile-sort>Access</th>
          <th scope="col" class="ac-actions-column">Actions</th>
        </tr>
      </thead>

      <tbody class="table-body">
        @for(member of filteredStaff(); track member.sumId){
        <tr>
          <td data-label="Name">{{ member.fullName }}</td>
          <td data-label="Username">{{ member.userName }}</td>
          <td data-label="Mobile">{{ member.mobileNumber || '-' }}</td>
          <td data-label="Access">{{ member.isRestricted ? 'Restricted' : 'Active' }}</td>
          <td class="ac-actions-column" data-label="Actions">
            <div class="actions-cell">
              <button type="button" class="ac-secondary-small-btn" [disabled]="isLoading" (click)="manage(member)">Manage</button>
              @if(canManage && !member.isSelf){
              <button type="button" class="ac-secondary-small-btn" [disabled]="isLoading" (click)="toggleRestricted(member)">
                {{ member.isRestricted ? 'Unrestrict' : 'Restrict' }}
              </button>
              }
            </div>
          </td>
        </tr>
        }

        @if(!isLoading && filteredStaff().length === 0){
        <tr class="ac-empty-table-row">
          <td colspan="5" class="empty-row">{{ search.value ? 'No users match the search.' : 'No Records Found' }}</td>
        </tr>
        }
      </tbody>
    </table>
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
